import type { ColumnDescriptor } from './types'

/**
 * Подпись колонки списка (тикет #106).
 *
 * Пользовательское поле подписывается тем, что ввёл администратор: словаря переводов для
 * него нет — поле появилось без релиза. Без этого заголовок колонки выглядел бы как
 * `column.budget_source`, и фильтр по полю, ради которого его заводили, никто бы не нашёл.
 */
export function columnLabel(
  t: (key: string) => string,
  descriptors: ColumnDescriptor[] | undefined,
  name: string,
): string {
  const custom = descriptors?.find((column) => column.name === name)?.label
  return custom ?? t(`column.${name}`)
}

/**
 * Можно ли группировать список по колонке.
 *
 * По тегам — нет: у записи их несколько, и группа на каждое сочетание — счётчики, которых
 * никто не просил. По пользовательскому полю (у него есть `label`) — тоже: значение живёт
 * в JSON, а не колонкой. Сервер отвергает оба (`list.not_groupable`); пункт, ведущий к
 * отказу, не предлагается.
 */
export function groupable(column: ColumnDescriptor): boolean {
  return column.name !== 'tags' && !column.label
}
